var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddPlaylist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.882 9.559a3.447 3.447 0 013.441-3.441 3.447 3.447 0 013.442 3.44A3.447 3.447 0 0110.323 13a3.446 3.446 0 01-3.44-3.441zm1.53 0a.382.382 0 00.382.382h1.147v1.147a.382.382 0 00.765 0V9.941h1.147a.382.382 0 000-.765h-1.147V8.03a.382.382 0 00-.765 0v1.147H8.794a.382.382 0 00-.382.383zM.382 6.882a.382.382 0 010-.764h3.824a.382.382 0 010 .764H.382zm0-3.058a.382.382 0 010-.765h13a.382.382 0 010 .765h-13zm0-3.06a.382.382 0 010-.764h13a.382.382 0 010 .765h-13z",
    fill: "#7A8D8F"
  })));
}
export default SvgAddPlaylist;